import { render, staticRenderFns } from "./rewardRecurrenceEdit.vue?vue&type=template&id=190eb0e2&scoped=true&"
import script from "./rewardRecurrenceEdit.vue?vue&type=script&lang=js&"
export * from "./rewardRecurrenceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190eb0e2",
  null
  
)

export default component.exports